export default class ViewTextAreaVO
{

	// ----------------------------------
	//	Properties
	// ----------------------------------

	defaultValue = '';
	name = "Text area";
	fieldType = 'textArea';
	uiComponent = 'view-text-area-field';
	description = 'Simple text area wihtout formatting.';

	constructor()
	{
		
	}
}